/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuartzScheduleType } from './quartzScheduleType';


export interface QuartzJobUpdateSpec { 
    /**
     * New trigger name.
     */
    trigger_name?: string;
    /**
     * New trigger group.
     */
    trigger_group?: string;
    /**
     * New trigger description.
     */
    description?: string;
    schedule_type?: QuartzScheduleType;
    /**
     * New trigger cron expression. Required if scheduleType is \"CRON\"
     */
    cron_expression?: string;
    /**
     * Time in milliseconds (e.g., 30000ms = 30 sec) for SIMPLE trigger.
     */
    repeat_interval?: number;
    /**
     * Number of times the job should repeat (-1 for infinite).
     */
    repeat_count?: number;
}
export namespace QuartzJobUpdateSpec {
}


